<template>
  <div class="business-index">
    <div class="fun-btn-box">
      <auth-button auth="mall:description:create">
        <el-button type="primary" class="fun-btn mr10" @click="onAdd" >+ 添加商场介绍</el-button>
      </auth-button>
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #name="{ row }">{{ row.name }}</template>
      <template #mallName="{ row }">{{ row.mallName }}</template>
      <template #cover="{ row }">
        <img class="image" :src="row.cover" alt="" srcset="">
      </template>
      <template #created="{ row }">{{ row.created ? $moment(row.created).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #operatorName="{ row }">{{ row.operatorName }}</template>
      <template #operation="{ scope }">
        <auth-button auth="mall:description:update">
          <el-button class="mr10" type="text" @click="onEdit(scope.row)">编辑</el-button>
        </auth-button>
        <auth-button auth="mall:description:delete">
          <el-button class="del" type="text" @click="onDelete(scope.row)">删除</el-button>
        </auth-button>
      </template>
    </Table>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList'
import { api_getMallDescPage, api_deleteMallDesc } from '@/api/business'
import Table from "@/components/Table/index";
export default {
  name: "marketCouponListIndex",
  mixins: [ tableList ],
  components: {
    AuthButton,
    Table,
  },
  data() {
    return {
      form: {},
      tableThData: [
        { prop: "name", label: "标题名称", minWidth: "180", },
        { prop: "mallName", label: "商场", minWidth: "180", },
        { prop: "cover", label: "封面图", minWidth: "180", },
        { prop: "created", label: "创建时间", minWidth: "180", },
        { prop: "operatorName", label: "操作人", minWidth: "120", },
        { prop: "operation", label: "操作", minWidth: "100", },
      ],
    };
  },
  created () {
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      const data = await api_getMallDescPage(params)
      console.log('data: ', data);
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },
    // 点击创建按钮
    onAdd() {
      this.$router.push({
        path: "/serverConfig/businessIntroduce/add"
      })
    },
    onDelete (row) {
      this.$baseConfirm(
        '是否删除该介绍？',
        { title: '提示', type: 'warning', },
        async () => {
          await api_deleteMallDesc({id: row.id})
          this.$baseMessage('操作成功', 'success')
          this.getList()
        }
      )
    },
    onEdit(row){
      this.$router.push({
        path: "/serverConfig/businessIntroduce/add?id=" + row.id
      })
    }
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.business-index {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .fun-btn-box {
    margin-top: 20px;
  }

  .del {
    color: #F74A4A;
  }
  ::v-deep{
    // 去除switch禁用 css
    .el-switch.is-disabled{
      opacity: 1;
    }
    .el-switch.is-disabled .el-switch__core, .el-switch.is-disabled .el-switch__label{
      cursor: pointer;
    }
  }
  .image{
    width: 120px;
    height: 56px;
    object-fit: fill;
    object-fit: contain;
    object-fit: cover;
    object-fit: none;
    object-fit: scale-down;
  }
}
</style>
